import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { Toaster } from "@/components/ui/Toast";
import { NotFoundPage } from "@/pages/errors/NotFoundPage";
import { setMutationErrorHandler } from "@/api/queries/errors";
import { toast } from "@/stores/toast";
import type { RouterContext } from "../router-context";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => (
    <AppShell>
      <NotFoundPage />
    </AppShell>
  ),
});

setMutationErrorHandler((_error, context) => {
  toast.error(context.action === "follow-store" || context.action === "follow-creator" ? "Couldn't follow — try again" : "Something went wrong — try again");
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
